import {
  Indicator,
  Item2,
  Root2
} from "../../../chunk-2AGHUWXU.mjs";
import "../../../chunk-NGPEH7IU.mjs";
import "../../../chunk-XYZUYCEL.mjs";
import "../../../chunk-MTQX4T3Q.mjs";
import "../../../chunk-SDALGTJ4.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/RadioGroup/RadioGroup.tsx
import { MdCheck } from "react-icons/md";
import { jsx, jsxs } from "react/jsx-runtime";
function RadioGroup({
  ref,
  className = "",
  ...rest
}) {
  const classes = ["buyscout-radio-group", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(Root2, { ref, className: classes, ...rest });
}
RadioGroup.displayName = "RadioGroup";
function RadioGroupItem({
  ref,
  ...props
}) {
  const {
    size = "md",
    disabled = false,
    className = "",
    ...rest
  } = props;
  const classes = [
    "buyscout-radio-item",
    `buyscout-radio-item--size-${size}`,
    disabled ? "buyscout-radio-item--disabled" : "",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx(Item2, { ref, className: classes, disabled, ...rest, children: /* @__PURE__ */ jsx(Indicator, { className: "buyscout-radio-item__indicator" }) });
}
RadioGroupItem.displayName = "RadioGroupItem";
function RadioCard(props) {
  const variant = props.variant ?? "card";
  const classes = ["buyscout-radio-card", `buyscout-radio-card--${variant}`, props.className].filter(Boolean).join(" ");
  if (props.variant === "swatch") {
    const { ref: ref2, variant: _variant2, swatch, className: _className2, style, ...rest2 } = props;
    return /* @__PURE__ */ jsx(Item2, { ref: ref2, className: classes, style: { ...style, backgroundColor: swatch }, ...rest2, children: /* @__PURE__ */ jsx(MdCheck, { "aria-hidden": true, className: "buyscout-radio-card__check" }) });
  }
  if (props.variant === "thumbnail") {
    const { ref: ref2, variant: _variant2, media, label, className: _className2, ...rest2 } = props;
    return /* @__PURE__ */ jsxs(Item2, { ref: ref2, className: classes, ...rest2, children: [
      /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "buyscout-radio-card__media", children: media }),
      /* @__PURE__ */ jsx("span", { className: "buyscout-radio-card__label", children: label })
    ] });
  }
  const { ref, variant: _variant, title, description, className: _className, ...rest } = props;
  return /* @__PURE__ */ jsxs(Item2, { ref, className: classes, ...rest, children: [
    /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "buyscout-radio-card__control", children: /* @__PURE__ */ jsx(Indicator, { className: "buyscout-radio-card__dot" }) }),
    /* @__PURE__ */ jsxs("span", { className: "buyscout-radio-card__content", children: [
      /* @__PURE__ */ jsx("span", { className: "buyscout-radio-card__title", children: title }),
      description && /* @__PURE__ */ jsx("span", { className: "buyscout-radio-card__description", children: description })
    ] })
  ] });
}
RadioCard.displayName = "RadioCard";
export {
  RadioCard,
  RadioGroup,
  RadioGroupItem
};
//# sourceMappingURL=RadioGroup.mjs.map